function SectionCandidateExperience() {
    return (
        <>
            <h4 className="twm-s-title">Work Experience</h4>
            <div className="twm-timing-list-wrap">
                <div className="twm-timing-list">
                    <div className="twm-time-list-date">2012 to 2016</div>
                    <div className="twm-time-list-title">B.Sc. in Physics</div>
                    <div className="twm-time-list-position">University of Delhi</div>
                    <div className="twm-time-list-discription">
                        <p>Comprehensive coursework in classical mechanics, electromagnetism,
          and optics; conducted undergraduate laboratory experiments in
          wave phenomena and circuit analysis.</p>
                    </div>
                </div>
                <div className="twm-timing-list">
                    <div className="twm-time-list-date">2016 to 2020</div>
                    <div className="twm-time-list-title">M.Sc. in Physics</div>
                    <div className="twm-time-list-position">Indian Institute of Science, Bangalore</div>
                    <div className="twm-time-list-discription">
                        <p>Specialized in quantum mechanics and statistical thermodynamics;
          completed thesis project on semiconductor nanostructures and their
          optical properties.</p>
                    </div>
                </div>
                <div className="twm-timing-list">
                    <div className="twm-time-list-date">2020 to 2023</div>
                    <div className="twm-time-list-title">Postgraduate Diploma in Science Education</div>
                    <div className="twm-time-list-position">Tata Institute of Fundamental Research </div>
                    <div className="twm-time-list-discription">
                        <p>Training in pedagogy and curriculum design for secondary and
          higher secondary physics; developed interactive lab modules and
          peer‐reviewed teaching demonstrations.</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionCandidateExperience;